import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../app/Store";
import { LoadingState } from "../app/LoadingState";
import { beginRequest, completeRequest, rejectRequest, RequestState } from "../app/store/RequestState";
import { getMultiSiteConfigurationSummary } from "./MultiSiteConfigurationApi";
import { ISiteConfigurationSummary } from "./MultiSiteConfigurationModels";

export const configurationSitesKey = (sites: string[]) => JSON.stringify([...new Set(sites)].sort());
interface ConfigurationEntry extends RequestState {
  data?: Record<string, ISiteConfigurationSummary>;
}
const initialState: Record<string, ConfigurationEntry> = {};
export const fetchMultiSiteConfiguration = createAsyncThunk(
  "multiSiteConfiguration/fetch",
  async (sites: string[], { signal }) =>
    (await getMultiSiteConfigurationSummary([...new Set(sites)].sort(), signal)).sites,
  {
    condition: (sites, { getState }) =>
      sites.length > 0 &&
      (getState() as RootState).multiSiteConfiguration[configurationSitesKey(sites)]?.loadingState !==
        LoadingState.Pending,
  }
);
const slice = createSlice({
  name: "multiSiteConfiguration",
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(fetchMultiSiteConfiguration.pending, (state, action) => {
        const entry = (state[configurationSitesKey(action.meta.arg)] ??= {
          loadingState: LoadingState.None,
        });
        beginRequest(entry, action.meta.requestId);
      })
      .addCase(fetchMultiSiteConfiguration.fulfilled, (state, action) => {
        const entry = state[configurationSitesKey(action.meta.arg)];
        if (entry && completeRequest(entry, action.meta.requestId)) {
          entry.data = action.payload;
        }
      })
      .addCase(fetchMultiSiteConfiguration.rejected, (state, action) => {
        const entry = state[configurationSitesKey(action.meta.arg)];
        if (entry) {
          rejectRequest(entry, action);
        }
      }),
});
export const multiSiteConfigurationReducer = slice.reducer;
